<template>
  <div>
    <div v-if="hasApply" class="">
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-width="80px"
        style="width:800px"
      >
        <el-form-item label="接口" prop="name">
          <el-select
            v-model="form.ifaceId"
            disabled
            clearable
            placeholder="请选择接口"
            style="width:350px"
          >
            <el-option
              v-for="item in ifaceList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="应用" prop="appId">
          <el-select
            v-model="form.appId"
            clearable
            placeholder="请选择应用"
            style="width:350px"
          >
            <el-option
              v-for="item in appList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="手机号" prop="phone">
          <el-input v-model="form.phone"></el-input>
        </el-form-item>

        <el-form-item label="申请需求" prop="auditContent">
          <el-input
            type="textarea"
            :rows="3"
            v-model="form.auditContent"
          ></el-input>
        </el-form-item>

        <el-form-item label="申请理由" prop="auditReason">
          <el-input
            type="textarea"
            :rows="3"
            v-model="form.auditReason"
          ></el-input>
        </el-form-item>

        <el-form-item label="选择字段" prop="auditFields">
          <el-checkbox-group v-model="form.auditFields">
            <el-checkbox
              v-for="(item, index) in fieldList"
              :label="item.enFiledName"
              :key="index"
              name="auditFields"
              >{{ item.filedName }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSubmitApp('form')"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div v-else>
      <el-table
        :data="applyList"
        border
        stripe
        style="width: 100%"
        header-row-class-name="header-row"
      >
        <el-table-column prop="appname" align="center" label="应用名称">
        </el-table-column>
        <el-table-column prop="ifacename" align="center" label="资源名称">
          <template #default="{row}">
            <router-link
              :to="'/interface/detail/' + row.ifaceId"
              style="color:#2A7EE3"
            >
              {{ row.ifacename }}
            </router-link>
          </template>
        </el-table-column>
        <el-table-column prop="filedname" align="center" label="字段">
        </el-table-column>
        <el-table-column prop="auditReason" align="center" label="申请原因">
        </el-table-column>

        <el-table-column align="center" label="是否通过">
          <template #default="{row}">
            {{
              row.isPass == null
                ? "待审核"
                : row.isPass == "1"
                ? "审核通过"
                : "未通过"
            }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="handleAppCurrentChange"
        layout="prev, pager, next"
        :current-page="applyPager.curPageNumber"
        :total="applyPager.total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { getAppList, getApplyList, addIface } from "@/api/user";
import { getIfaceDetail, getDataItemList } from "@/api/index";
import { deepClone } from "@/utils/tool";
export default {
  props: {
    hasApply: {
      type: Boolean,
      default: false
    },
    dataset: {
      type: String,
      default: ""
    },
    iface: {
      type: String,
      default: ""
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      if (this.hasApply == true) {
        this.getApplyInfo();
      } else {
        this.init();
      }
    });
  },

  data() {
    return {
      form: {
        ifaceId: "",
        appId: "",
        phone: "",
        auditContent: "",
        auditReason: "",
        auditFields: []
      },
      rules: {
        auditContent: [
          { required: true, message: "请输入申请需求", trigger: "blur" },
          {
            min: 2,
            max: 100,
            message: "长度在 2 到 100 个字符",
            trigger: "blur"
          }
        ],
        auditReason: [
          { required: true, message: "申请理由", trigger: "blur" },
          {
            min: 2,
            max: 100,
            message: "长度在 2 到 100 个字符",
            trigger: "blur"
          }
        ],

        phone: [
          { required: true, trigger: "blur", message: "请输入手机号" },
          {
            pattern: /^[1]([3-9])[0-9]{9}$/,
            message: "手机号格式不对",
            trigger: "blur"
          }
        ],

        appId: [
          { required: true, message: "请选择申请应用", trigger: "change" }
        ],
        auditFields: [
          { required: true, message: "请选择申请字段", trigger: "change" }
        ],
        ifaceId: [
          { required: true, message: "请选择申请接口", trigger: "change" }
        ]
      },
      showAppList: true,
      applyTypeList: [],
      applyList: [],
      applyPager: {
        pageSize: 10,
        curPageNumber: 1,
        total: 0
      },
      ifaceList: [],
      appList: [],
      fieldList: []
    };
  },
  created() {
    this.init();
  },
  methods: {
    onSubmitApp(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          var data = deepClone(this[formName]);
          data.auditFields = data.auditFields.join(",");
          let { message } = await addIface(data);
          this.$message({
            message: message,
            type: "success"
          });
          this.getApplyList();
          this.changeHasApply = false;
          this.$emit("changeHasApply", false);
        }
      });
    },

    async getApplyInfo() {
      var { result } = await getIfaceDetail({ id: this.iface });
      this.ifaceList = [result];
      this.form.ifaceId = result.id;
      var { result } = await getAppList({ pageSize: 100 });
      this.appList = result.data;
      this.form.appId = result.data[0] ? result.data[0].id : "";
      var { result } = await getDataItemList({ datasetId: this.dataset });
      this.fieldList = result;
    },
    async init() {
      await this.getApplyList();
      this.loading = false;
    },
    handleAppCurrentChange(val) {
      this.applyPager.curPageNumber = val;
      this.getApplyList();
    },
    async getApplyList() {
      await getApplyList(this.applyPager)
        .then(response => {
          this.applyList = response.result.data.list;
          this.applyPager.total = response.result.count;
          this.applyPager.pageSize = response.result.pager.pageSize++;
          this.applyPager.curPageNumber = response.result.pager.curPageNumber;
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
};
</script>
